/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useState } from 'react';
import styled from 'styled-components';

import Txt from '../atoms/Txt';
import Row from '../atoms/FlexRow';

const InputData = styled.input`
  color: black;
  text-align: center;
  border: ${({ visible }) => (visible ? 'none' : null)};
  background: ${({ visible }) => (visible ? 'transparent' : null)};
  height: 30px;
  width: 220px;
  position: absolute;
  left: calc(50% - 110px);

  @media (max-width: 768px) {
    position: unset;
  }
`;

function InputUserData({ value, text, onEdit: onSubmit }) {
  const [editingMode, setEditingMode] = useState(false);
  const [newValue, setNewValue] = useState(value);

  const handleChange = (e) => {
    if (editingMode) setNewValue(e.target.value);
  };

  return (
    <Row justify="space-between" position="relative">
      <Txt>{text}</Txt>
      <InputData
        type="text"
        visible={!editingMode}
        value={editingMode ? newValue : value}
        disabled={!editingMode}
        onChange={handleChange}
      />
      <i
        onClick={() => {
          setEditingMode(!editingMode);
          if (editingMode) {
            onSubmit(newValue);
          } else {
            setNewValue(value);
          }
        }}
        className={editingMode ? 'fas fa-check' : 'fas fa-pencil-alt'}
      />
    </Row>
  );
}

export default InputUserData;
